export const validateEmailAddress = (email: string) => {
	const regex =
		/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
	return regex.test(email)
}

export const validatePhoneNumber = (number: any) => {
	// Simple regex to check if the phone number is not just mask characters
	const regex = /\(\d{3}\) \d{3}-\d{4}/
	return regex.test(number)
}

export const validatePassword = (password: string) => {
	const regexp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/
	return regexp.test(password)
}
